import React from 'react'
import styles from './MobileMenuNotification.module.scss'

interface OwnProps {
  onClick: () => void
  className: string
  value?: number
  displayValue?: boolean
}

const MobileMenuNotification = ({ onClick, className, displayValue, value }: OwnProps) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault()
    onClick()
  }

  return (
    <a className={`${styles.mobileMenuNotification} ${className}`} onClick={handleClick}>
      {displayValue && <div>{value}</div>}
    </a>
  )
}

export default MobileMenuNotification
